import React, { Component } from "react";
import logo from "../logo.svg";
import "../navupd.css";
import { Link, Redirect } from "react-router-dom";
import Search from "./searchbar";

class Navbar extends Component {
  state = {
    value: "NCR",
    item: [
      "NCR",
      "Ahmedabad",
      "Banglore",
      "Chennai",
      "Mumbai",
      "Hyderbad",
      "Pune",
    ],
  };
  handleSubmit = (data) => {
    let { value } = this.state;
    this.props.onSubmit(data);
  };

  render() {
    let { item } = this.state;
    let value = this.props.value;
    console.log(this.props.region);
    return (
      <div>
        <nav className="navbar  navbar-expand-sm navbar-light bg-dark">
          <Link to="/movies/NCR">
            <img src={logo} className="mt-0"></img>
          </Link>
          <div className="collapse navbar-collapse ml-5 form-group">
            <div className="col-sm-10 col-lg-5 ">
              <Search onSubmit={this.handleSubmit} />
            </div>
            <div className="col-4 text-right">
              <li class="nav-item dropdown d-sm-none d-md-block float-right text-right">
                <span className="text-light">
                  {value}
                  <i
                    className="nav-link fa fa-chevron-down text-white dropdown-btn p-2"
                    id="onhover"
                    style={{ fontSize: "10px", color: "lightgrey" }}
                  />
                </span>

                <div
                  className="dropdown-content text-left"
                  aria-labelledby="navbarDropdown"
                >
                  <ul>
                    {item.map((vl) => (
                      <Link
                        to={{
                          pathname: "/movies/" + vl,
                          search: "",
                        }}
                        className="text-dark"
                      >
                        {vl}
                        <br />
                      </Link>
                    ))}
                  </ul>
                </div>
              </li>
            </div>
            <span className="text-white text-center col-2 d-sm-none d-md-block">
              English
            </span>
            <button className="btn btn-sm btn-outline-light d-sm-none d-md-block">
              SignIn
            </button>
          </div>
        </nav>
        <div className="container-fluid">
          <div className="row bg-dark text-white text-center mb-2">
            <div className="col-2">Movies</div>
            <div className="col-2">Events</div>
            <div className="col-2">Plays</div>
            <div className="col-2">Activities</div>
            <div className="col-2">Fanhood</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;
